import { TextField } from '@mui/material';
import { handleSingleLineKeys } from 'src/graphql/entities/custom-attributes/field-view-registry/components/single-line-input';
import { CustomAttributeEditProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { useAutoFocusInput } from 'src/utils/hooks/use-autofocus-input';
import { useSettleCallbackOnce } from 'src/utils/hooks/use-settle-callback-once';
import { TextKind } from './text-view';

const MIN_ROWS = 2;

const MAX_ROWS = 4;

const renderTextEditor = (kind: TextKind, multiline: boolean) => {
  const Editor = ({
    value,
    onChange,
    onSave,
    onCancel,
    disabled,
  }: CustomAttributeEditProps) => {
    const textValue = getKindLikeValueSafely(value, kind) ?? '';
    const inputRef = useAutoFocusInput({ select: !multiline });
    const callbacks = useSettleCallbackOnce({ onSave, onCancel });

    return (
      <TextField
        inputRef={inputRef}
        value={textValue}
        onChange={(event) => onChange({ kind, value: event.target.value || null })}
        onBlur={callbacks.onSave}
        onKeyDown={handleSingleLineKeys({ ...callbacks, saveOnEnter: !multiline })}
        disabled={disabled}
        size="small"
        fullWidth
        multiline={multiline}
        minRows={multiline ? MIN_ROWS : undefined}
        maxRows={multiline ? MAX_ROWS : undefined}
        autoComplete="off"
      />
    );
  };

  Editor.displayName = `${kind}-editor`;

  return Editor;
};

export const ShortTextEditor = renderTextEditor('short_text', false);

export const MultiLineTextEditor = renderTextEditor('multi_line_text', true);
